import { DEFAULT_CIP_CHEMICALS } from "../../constants/global.constants";

export const CHEMICAL_FIELDS_CONFIG = {
  acid: {
    titleKey: "defaultInformationStrings.acid_cip_ph",
    chemicalLabelKey: "defaultInformationStrings.acidchemicalLabel",
    priceKey: "acidPrice",
    chemicalKey: "acid_chemical",
    defaultOption: DEFAULT_CIP_CHEMICALS.ACID.chemical_name,
  },
  alkali: {
    titleKey: "defaultInformationStrings.alkali_cip_ph",
    chemicalLabelKey: "defaultInformationStrings.alkalichemicalLabel",
    priceKey: "alkaliPrice",
    chemicalKey: "alkali_chemical",
    defaultOption: DEFAULT_CIP_CHEMICALS.ALKALI.chemical_name,
  },
  additive_alkali: {
    titleKey: "defaultInformationStrings.cip_additive_ph",
    chemicalLabelKey: "defaultInformationStrings.additiveChemicalLabel",
    priceKey: "additive_alkali_price",
    chemicalKey: "additive_alkali",
    defaultOption: DEFAULT_CIP_CHEMICALS.CIP_ADDITIVE.chemical_name,
  },
};

export const CHEMICAL_FIELDS_KEYS = Object.keys(CHEMICAL_FIELDS_CONFIG);
